import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const Register = ({ onLoginClick }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { register, authError } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }
    
    if (password.length < 6) {
      setError('Пароль должен быть не менее 6 символов');
      return;
    }
    
    setLoading(true);

    const result = await register(email, password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <div className="auth-info-panel">
          <div className="auth-brand">
            <div className="brand-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#brandGrad)" stroke="white" strokeWidth="2"/>
                <text x="24" y="32" textAnchor="middle" fill="white" fontSize="24" fontWeight="700" fontFamily="system-ui">1С</text>
                <defs>
                  <linearGradient id="brandGrad" x1="0" y1="0" x2="48" y2="48">
                    <stop offset="0%" stopColor="#667eea"/>
                    <stop offset="100%" stopColor="#764ba2"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h1 className="brand-title">1С в LXC</h1>
            <p className="brand-subtitle">Платформа нового поколения</p>
            <div className="brand-badge">
              <span className="badge-mvp">MVP</span>
              <span className="badge-status">Регистрация</span>
            </div>
          </div>

          <div className="auth-features">
            <h3 className="features-title">Преимущества платформы</h3>
            <ul className="features-list">
              <li>
                <span className="feature-icon">⚡</span>
                <span className="feature-text">Создание контейнеров для 1С</span>
              </li>
              <li>
                <span className="feature-icon">🔒</span>
                <span className="feature-text">Безопасное хранение данных</span>
              </li>
              <li>
                <span className="feature-icon">📈</span>
                <span className="feature-text">Масштабирование до 50 контейнеров</span>
              </li>
              <li>
                <span className="feature-icon">🔄</span>
                <span className="feature-text">Автоматическое резервное копирование</span>
              </li>
            </ul>
          </div>

          <div className="auth-footer-info">
            <div className="footer-badges">
              <span className="footer-badge">🔐 Безопасно</span>
              <span className="footer-badge">📦 1С:Предприятие</span>
            </div>
            <p className="footer-version">Присоединяйтесь к платформе</p>
          </div>
        </div>

        <div className="auth-form-panel">
          <div className="auth-card">
            <div className="auth-header">
              <h2 className="auth-title">Создать аккаунт</h2>
              <p className="auth-subtitle">Начните работу с платформой 1С в LXC</p>
            </div>
            
            {(error || authError) && (
              <div className="auth-error">
                <i className="fas fa-exclamation-circle"></i>
                <span>{error || authError}</span>
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">
                  <i className="fas fa-envelope"></i>
                  Email
                </label>
                <div className="input-wrapper">
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="user@company.ru"
                    required
                    disabled={loading}
                    className={email ? 'filled' : ''}
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="password">
                  <i className="fas fa-lock"></i>
                  Пароль
                </label>
                <div className="input-wrapper password-wrapper">
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Не менее 6 символов"
                    required
                    disabled={loading}
                    className={password ? 'filled' : ''}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                  >
                    <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">
                  <i className="fas fa-check-circle"></i>
                  Подтвердите пароль
                </label>
                <div className="input-wrapper password-wrapper">
                  <input
                    id="confirmPassword"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Повторите пароль"
                    required
                    disabled={loading}
                    className={confirmPassword ? 'filled' : ''}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    disabled={loading}
                  >
                    <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                  </button>
                </div>
              </div>
              
              <button 
                type="submit" 
                className="auth-submit-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner"></span>
                    Регистрация...
                  </>
                ) : (
                  <>
                    <span>Зарегистрироваться</span>
                    <i className="fas fa-user-plus"></i>
                  </>
                )}
              </button>
            </form>
            
            <div className="auth-footer">
              <p>
                Уже есть аккаунт?{' '}
                <button 
                  className="auth-link" 
                  onClick={onLoginClick}
                  disabled={loading}
                >
                  Войти
                </button>
              </p>
            </div>

            <div className="auth-system-info">
              <div className="system-status">
                <span className="status-dot"></span>
                <span className="status-text">Платформа готова к работе</span>
              </div>
              <div className="system-metrics">
                <span>🚀 Быстрый старт</span>
                <span>🔐 Безопасно</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;